export default {
  credentialsModal: {
    kioskCode: "Gerätecode",
    password: "Passwort",
    qrHelp:
      "Scannen Sie diesen QR-Code auf dem Tablet-Anmeldebildschirm, um die Zugangsdaten automatisch auszufüllen.",
    securityWarningTitle: "Sicherheitshinweis:",
    securityWarningBody:
      "Jeder, der diesen QR-Code scannt, kann sich anmelden, bis Sie das Passwort neu generieren.",
  },
  posConfig: {
    title: "Kartenleser verknüpfen",
    linkedReaderTitle: "Verknüpfter Kartenleser",
    readerId: "Anbieter-Kartenleser-ID",
    refreshFromSumup: "Von SumUp aktualisieren",
    disconnect: "Verknüpfung aufheben",
    replaceWithNewPairing: "Durch anderen Kartenleser ersetzen",
    searchSerialPlaceholder: "Nach Seriennummer suchen…",
    showMockReaders: "Mock-Terminals anzeigen",
    noAvailableReaders:
      "Keine verknüpfbaren Kartenleser gefunden. Koppeln Sie zuerst einen SumUp-Kartenleser in der Kartenleser-Verwaltung.",
    selectReaderRequired:
      "Wählen Sie einen verfügbaren Kartenleser anhand der Seriennummer.",
    linkReplace: "Verknüpfen & ersetzen",
    linkReader: "Kartenleser verknüpfen",
    linkMockReader: "Mock-Kartenleser verknüpfen",
    unlinkConfirm:
      "Verknüpfung dieses Kartenlesers mit dem Tablet aufheben? Die SumUp-Kopplung bleibt erhalten; Zahlungen bleiben deaktiviert, bis Sie erneut verknüpfen.",
  },
} as const;
